module.exports = __webpack_public_path__ + "static/bainun-42c5274d0740cd516176853ec8f7d4a2.png";